import React from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';
import '../trust-homepage.css';

export const FREQUENTLY_ASKED_QUESTIONS = [
  {
    question: '¿Puede conectarse con cualquier programa?',
    answer: 'Primero revisamos la cuenta, los permisos y las opciones reales de conexión. Antes de empezar te decimos qué información puede consultar Áncora, qué tareas puede realizar y qué queda fuera.',
  },
  {
    question: '¿Puede atender a mis clientes por WhatsApp?',
    answer: 'Sí. Áncora puede responder mensajes, recoger la información necesaria y continuar la gestión acordada. Si el caso necesita una decisión o se sale de las reglas, lo pasa a tu equipo.',
  },
  {
    question: '¿Puede consultar mi agenda o mi CRM?',
    answer: 'Puede hacerlo cuando la herramienta permite una conexión compatible y tiene los permisos necesarios. Antes de empezar comprobamos qué datos puede consultar y qué acciones puede realizar.',
  },
  {
    question: '¿Puede gestionar solicitudes de cita?',
    answer: 'Puede recoger los datos, consultar la disponibilidad cuando la conexión lo permite y preparar o gestionar la solicitud según las reglas acordadas. Las excepciones se pasan al equipo.',
  },
  {
    question: '¿Qué necesita Áncora para empezar?',
    answer: 'Empezamos por una tarea concreta. Revisamos el canal, la herramienta, los datos necesarios, los permisos y cuándo debe intervenir una persona. Con eso definimos una propuesta y unas pruebas claras.',
  },
  {
    question: '¿Qué pasa si un cliente pide algo que no está previsto?',
    answer: 'Áncora no improvisa una decisión. Recoge el contexto y pasa el caso al equipo para que una persona continúe.',
  },
  {
    question: '¿Qué ocurre si la IA no debe decidir?',
    answer: 'Áncora pasa el caso a tu equipo con la información disponible. Antes de empezar acordamos qué decisiones puede tomar y cuáles debe dejar a una persona.',
  },
  {
    question: '¿Se pueden añadir otras herramientas o tareas?',
    answer: 'Podemos estudiarlas contigo. Revisamos si existe una conexión compatible, qué permisos requiere y qué trabajo supone antes de incluirla en el alcance.',
  },
] as const;

export const FrequentlyAskedQuestions: React.FC = () => (
  <section className="trust-section trust-faq-page" aria-labelledby="frequently-asked-questions-title">
    <div className="marketing-grid trust-faq-page__layout">
      <div className="trust-faq-page__intro">
        <h1 id="frequently-asked-questions-title">Preguntas frecuentes</h1>
        <p>Respuestas claras sobre cómo trabaja Áncora, qué puede conectar y cuándo interviene tu equipo.</p>
      </div>
      <div className="trust-faq-page__questions">
        {FREQUENTLY_ASKED_QUESTIONS.map((faq) => (
          <details key={faq.question}>
            <summary>
              <HelpCircle className="trust-faq-page__question-icon" aria-hidden="true" size={21} />
              <span>{faq.question}</span>
              <ChevronDown className="trust-faq-page__toggle-icon" aria-hidden="true" size={19} />
            </summary>
            <p>{faq.answer}</p>
          </details>
        ))}
      </div>
    </div>
  </section>
);
